import { makeLabels } from '../../utils/i18n';

export const NAMESPACE = 'page.notImplemented';
export const LABELS = makeLabels(
  {
    BREADCRUMBS: ['breadcrumbs', 'Under construction'],
    PAGE_TITLE: ['title', 'Not implemented'],
    PAGE_BODY: ['body', "The ramp service is no longer available, so any previous or new ramp transactions won't appear here."],
  },
  NAMESPACE,
);
